import { createActionsHook } from 'src/lib/sweetState';

import { CustomFormulasStore } from './CustomFormulasStore';

export const useCustomFormulasActions = createActionsHook(CustomFormulasStore);
